import { AccessHandlerEntitlementGroupsTranslation } from 'locales/de/pages/Access-Handler/entitlementGroups';

const en: AccessHandlerEntitlementGroupsTranslation = {
  title: 'Entitlementgroups',
  createRole: 'Create Role',
  tableHeader: {
    entitlements: 'Entitlements',
    entitlementGroup: 'Entitlementgroup',
    roles: 'Roles'
  },
  model: {
    name: 'Rolename',
    entitlementGroups: 'Entitlementgroups',
    permissions: 'Permissions'
  },
  form: {
    entitlements: 'Entitlements'
  },
  modal: {
    included: 'Included',
    notIncluded: 'Not included'
  },
  deleteConfirm: {
    title: 'Really delete?',
    message: 'Do you really want to delete this entitlementgroup?'
  },
  alerts: {
    errorLoadingEntitlements: 'The entitlements could not be loaded.',
    errorLoading: 'The entitlementgroups could not be loaded.',
    saveFailed: 'The entitlementgroup could not be saved.',
    saveSuccess: 'The entitlementgroup has been saved.',
    deleteFailed: 'The entitlementgroup could not be deleted.',
    deleteSuccess: 'The entitlementgroup has been deleted.'
  }
};

export default en;
